import React, { useState } from 'react';

import '../css/Header.css';

import logo from '../img/logos/escudo.png';

import facebook from '../img/logos/facebook-R.png';
import instagram from '../img/logos/instagran-R.png';
import twitter from '../img/logos/x-R.png';
import youtube from '../img/logos/youtube-R.png';

const Header = () => {

    const [iconHovered, setIconHovered] = useState(null);

    const handleIconClick = (icon) => {

        if (iconHovered === icon) {

            setIconHovered(null);

        } else {

            setIconHovered(icon);

        }

    };

    return (

        <header className="esc-header">

            {/* Barra superior */}

            <div className="esc-header-top">

                <div className="esc-header-phone">

                    📞 (+562) 27103043

                </div>

                <div className="esc-header-social">

                    <span className="esc-header-social-text">

                        Comunícate con nosotros

                    </span>

                    <a
                        href="https://www.instagram.com/nuevazelandiaescuela/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleIconClick('instagram')}
                    >
                        <img
                            src={instagram}
                            alt="Instagram"
                            className={`esc-header-icon ${iconHovered === 'instagram' ? 'esc-active' : ''}`}
                        />
                    </a>

                    <a
                        href="https://twitter.com/zelandia_nueva?lang=bg/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleIconClick('twitter')}
                    >
                        <img
                            src={twitter}
                            alt="X"
                            className={`esc-header-icon ${iconHovered === 'twitter' ? 'esc-active' : ''}`}
                        />
                    </a>

                    <a
                        href="https://www.facebook.com/EscuelaNuevaZelancia"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleIconClick('facebook')}
                    >
                        <img
                            src={facebook}
                            alt="Facebook"
                            className={`esc-header-icon ${iconHovered === 'facebook' ? 'esc-active' : ''}`}
                        />
                    </a>

                    <a
                        href="https://www.youtube.com/channel/UCv9kvVQXl1zXASkSQfra55w"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => handleIconClick('youtube')}
                    >
                        <img
                            src={youtube}
                            alt="YouTube"
                            className={`esc-header-icon ${iconHovered === 'youtube' ? 'esc-active' : ''}`}
                        />
                    </a>

                </div>

            </div>

            {/* Encabezado principal */}

            <div className="esc-header-main">

                <div className="esc-header-logo">

                    <img
                        src={logo}
                        alt="Escuela Nueva Zelandia"
                    />

                </div>

                <div className="esc-header-info">

                    <h1>

                        ESCUELA NUEVA ZELANDIA

                    </h1>

                    <p>

                        Educación Pública de Calidad

                    </p>

                </div>

            </div>

        </header>

    );

};

export default Header;